import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  Grid,
  InputAdornment,
  MenuItem,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreateAdminEditPunchMutation,
  useGetTeamSerchOnlyQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import NewPrinter from "../../Printer/Edit/index";
import { useStyles } from "../../../theme/appStyles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { PunchStatus } from "../../../Core/Enum/enum";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { ITeam } from "../../../Api/Interface/api.interface";
import { useSearchParams } from "react-router-dom";

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const paymentMonthYear = searchParams.get("date");
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [newDepartment, { isLoading }] = useCreateAdminEditPunchMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  const [openPrinter, setOpenPrinter] = useState(false);
  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
  const debouncedSearchQueryCustomer = useDebounce(searchQueryCustomer, 300);
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);

  const {
    data: tenantData,
    isLoading: tenantIsLoading,
    isError,
    refetch,
  } = useGetTeamSerchOnlyQuery({
    searchText: searchQueryCustomer,
    id: "",
  });

  const teamList: ITeam[] = Array.isArray(tenantData?.data)
    ? (tenantData?.data as ITeam[])
    : [];

  const formik = useFormik({
    initialValues: {
      empid: "",
      //   punched_date: dayjs(paymentMonthYear.toString()).format(
      //     "YYYY-MM-DD h:mm:ss A"
      //   ),
      punched_date: paymentMonthYear
        ? dayjs(paymentMonthYear.toString()).format("YYYY-MM-DD h:mm:ss A")
        : dayjs().format("YYYY-MM-DD h:mm:ss A"),
      punched_time: paymentMonthYear
        ? dayjs(paymentMonthYear.toString()).format("YYYY-MM-DD HH:mm:ss")
        : dayjs().format("YYYY-MM-DD HH:mm:ss"),
      punch_action: "",
      punch_status: 0,
      created_time: "",
      updated_time: "",
      delayReason: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          empid: values.empid,
          punched_date: values.punched_time,
          punched_time: values.punched_time,
          punch_action: values.punch_action,
          punch_status: values.punch_status,
          created_time: values.punched_time,
          updated_time: values.punched_time,
          delayReason: values.delayReason,
        };

        const addCompanyResponse = await newDepartment(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setSearchQueryCustomer("");
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const handleSelectCustomer = (team: ITeam) => {
    formik.setFieldValue("empid", team.id);
    setSearchQueryCustomer(
      `${team.teamFirstName || ""} ${team.teamLastName || ""}`
    );
    setShowDropdownCustomer(false);
  };

  const handleFocusOrClickCustomer = () => {
    setShowDropdownCustomer(true);
    if (currentSearchQueryCustomer === "") {
      refetch();
    }
  };

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQueryCustomer(value);
    if (!value.trim()) {
      formik.setFieldValue("empid", "");
    }
  };

  const cancelFunction = () => {
    formik.resetForm();
    setSearchQueryCustomer("");
  };

  const formValid = useMemo(() => {
    return formik.values.empid === "" ||
      formik.values.empid === undefined ||
      formik.values.punch_action === "" ||
      formik.values.punch_action === undefined ||
      // formik.values.punched_date === "" ||
      // formik.values.punched_date === undefined ||
      formik.values.punched_time === "" ||
      formik.values.punched_time === undefined
      ? false
      : true;
  }, [formik]);

  return (
    <Grid container spacing={3}>
      <Grid item lg={3} md={12} sm={12} xs={12}>
        <Card className={classes.stepperCard}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>Edit</Typography>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={9} md={12} sm={12} xs={12}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Punch Details
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={3} p={"24px"}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                          Staff Name{" "}
                          <span className={classes.requiedfield}> *</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" sx={{ pr: 2 }}>
                                <CiSearch
                                  className={classes.searchWidgetIcon}
                                />
                              </InputAdornment>
                            ),
                          }}
                          value={searchQueryCustomer}
                          onChange={handleTextFieldChange}
                          placeholder="Name & phone number .."
                          size="small"
                          onFocus={handleFocusOrClickCustomer}
                          onClick={handleFocusOrClickCustomer}
                          sx={{ flexGrow: 1, width: "100%" }}
                          InputLabelProps={{ shrink: true }}
                        />
                        {showDropdownCustomer && (
                          <Paper className={classes.dropdownPaper}>
                            {tenantIsLoading ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  padding: "10px",
                                }}
                              >
                                <CircularProgress size={24} />
                              </div>
                            ) : (
                              teamList.length > 0 &&
                              teamList.map((team) => (
                                <MenuItem
                                  key={team.id}
                                  onClick={() => handleSelectCustomer(team)}
                                >
                                  {`${team.teamFirstName || ""} ${
                                    team.teamLastName || ""
                                  }`}
                                </MenuItem>
                              ))
                            )}
                          </Paper>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                          Punch Action{" "}
                          <span className={classes.requiedfield}> *</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          select
                          size="small"
                          className={classes.textField}
                          SelectProps={{
                            native: false,
                          }}
                          defaultValue=""
                          InputLabelProps={{ shrink: true }}
                          {...formik.getFieldProps("punch_action")}
                        >
                          <MenuItem value="" disabled>
                            Select some option
                          </MenuItem>

                          {Object.entries(PunchStatus).map(
                            ([key, value], index) => (
                              <MenuItem key={index} value={value}>
                                {key}
                              </MenuItem>
                            )
                          )}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                          Punched Date{" "}
                          <span className={classes.requiedfield}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={
                              formik.values.punched_date
                                ? dayjs(
                                    formik.values.punched_date,
                                    "YYYY-MM-DD h:mm:ss A"
                                  )
                                : null
                            }
                            onChange={(newValue) => {
                              // Format the selected date
                              const formattedDate = newValue
                                ? newValue.format("YYYY-MM-DD")
                                : "";

                              // Get the current time formatted as "h:mm:ss A"
                              const currentTime = dayjs().format("h:mm:ss A");

                              // Combine date and time
                              const combinedDateTime = formattedDate
                                ? `${formattedDate} ${currentTime}`
                                : "";

                              // Set the field value in formik
                              formik.setFieldValue(
                                "punched_date",
                                combinedDateTime
                              );
                            }}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                                InputProps: {
                                  sx: { fontSize: 14 },
                                },
                                InputLabelProps: {
                                  sx: { fontSize: 14 },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid> */}

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                          Punched Date & Time{" "}
                          <span className={classes.requiedfield}> *</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            value={
                              formik.values.punched_time
                                ? dayjs(formik.values.punched_time)
                                : null
                            }
                            onChange={(newValue) => {
                              // Format the date-time value
                              const formattedDateTime = newValue
                                ? newValue.format("YYYY-MM-DD HH:mm:ss")
                                : "";
                              formik.setFieldValue(
                                "punched_time",
                                formattedDateTime
                              );
                            }}
                            // viewRenderers={{
                            //   hours: renderTimeViewClock,
                            //   minutes: renderTimeViewClock,
                            //   seconds: renderTimeViewClock,
                            // }}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                                InputProps: {
                                  sx: { fontSize: 14 },
                                },
                                InputLabelProps: {
                                  sx: { fontSize: 14 },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Remark</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Remark .."
                          size="small"
                          multiline
                          rows={8}
                          {...formik.getFieldProps("delayReason")}
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
              <Card className={classes.card}>
                <Grid container spacing={3} p={"24px"}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={cancelFunction}
                    >
                      Reset
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                      variant="contained"
                      startIcon={
                        isLoading ? (
                          <CircularProgress
                            size={18}
                            className={classes.isLoading}
                          />
                        ) : (
                          <SaveAltIcon />
                        )
                      }
                      className={classes.addButton}
                      onClick={() => formik.handleSubmit()}
                      disabled={!formValid || isLoading}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>

          {openPrinter && (
            <NewPrinter
              handleCloseDialog={() => setOpenPrinter(false)}
              openModel={openPrinter}
            />
          )}
        </form>
      </Grid>
    </Grid>
  );
};

export default Index;
